import { LoadingTypes } from 'src/app/shared/models/enums/loading.enum';

export enum PostOfferWorkflowLoadingStateType {
    FetchPermBillingInformation = 1,
    FetchJobBillRate = 2,
    FetchRemovalReasons = 3,
    FetchPostOfferData = 4,
    SaveSubmittalStatusAndPostOfferInfo = 5,
    UpdatePostOfferBillingInfo = 6,
    SetConfirmNotStarting = 7
}

export interface PostOfferWorkflowLoadingState {
    loadingType: LoadingTypes;
    loadingStateType: PostOfferWorkflowLoadingStateType;
}
